// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".stationInfo__placeholder{min-height:250px}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/components/reporting/ReportingInfo.vue"],"names":[],"mappings":"AAsBE,0BACE,gBAAA","file":"ReportingInfo.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.stationInfo {\n  &__placeholder {\n    min-height: 250px;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
